import {useEffect} from "react";
import {useForm, Controller} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {ModalForm} from "~/components";
import {InputField, SelectField, TextAreaField} from "~/components/Forms";

const schema = Yup.object().shape({
	keyword: Yup.string().trim().required('Vui lòng nhập từ khoá chính'),
});

const TYPE_OPTIONS = [
	{value: 'guide', label: 'Bài hướng dẫn (how-to)'},
	{value: 'compare', label: 'Bài so sánh / đánh giá'},
	{value: 'list', label: 'Bài danh sách (listicle)'},
	{value: 'news', label: 'Bài tin tức / cập nhật'},
];

const LENGTH_OPTIONS = [
	{value: 'Ngắn (~700 từ)', label: 'Ngắn (~700 từ)'},
	{value: 'Trung bình (~1200 từ)', label: 'Trung bình (~1200 từ)'},
	{value: 'Dài (~2000 từ)', label: 'Dài (~2000 từ)'},
];

/**
 * Modal xếp hàng 1 bài viết AI mới (Đợt 1 — bài lẻ): từ khoá chính + phụ + loại + độ dài.
 * Pipeline nền lo phần còn lại (intent → dàn ý → viết → ảnh → checklist).
 */
function ContentNewModal({open, submitting, onCancel, onSubmit}) {

	const {control, handleSubmit, reset, formState: {errors}} = useForm({
		defaultValues: {keyword: '', sub_keywords: '', article_type: 'guide', length: 'Trung bình (~1200 từ)'},
		resolver: yupResolver(schema),
	});

	useEffect(() => {
		if (open) reset({keyword: '', sub_keywords: '', article_type: 'guide', length: 'Trung bình (~1200 từ)'});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [open]);

	return (
		<ModalForm
			open={open}
			icon="fa-light fa-feather-pointed"
			title="Viết bài mới bằng AI"
			subtitle="AI phân tích search intent thật rồi tự lên dàn ý và viết bài trong nền"
			onCancel={onCancel}
			onOk={handleSubmit(onSubmit)}
			okText="Bắt đầu viết"
			loading={submitting}
		>
			<Controller control={control} name="keyword" render={({field}) => (
				<InputField label="Từ khoá chính" placeholder="vd: cách tối ưu Core Web Vitals" errors={errors} {...field} />
			)} />
			<Controller control={control} name="sub_keywords" render={({field}) => (
				<TextAreaField label="Từ khoá phụ (tuỳ chọn, mỗi dòng 1 từ)" rows={3}
					placeholder={"tối ưu LCP\ntối ưu CLS"} errors={errors} {...field} />
			)} />
			<Controller control={control} name="article_type" render={({field}) => (
				<SelectField label="Loại bài" options={TYPE_OPTIONS} style={{width: '100%'}} {...field} />
			)} />
			<Controller control={control} name="length" render={({field}) => (
				<SelectField label="Độ dài mong muốn" options={LENGTH_OPTIONS} style={{width: '100%'}} {...field} />
			)} />
		</ModalForm>
	);
}

export default ContentNewModal;
